import * as viewportUnitsBuggyfill from 'viewport-units-buggyfill';

viewportUnitsBuggyfill.init({
	hacks: viewportUnitsBuggyfill.hacks,
	refreshDebounceWait: 250
});

// orientationchange
// window.addEventListener('resize', viewportUnitsBuggyfill.refresh, true);

const Mirai = require('./include/_mirai')();

// require('./include/_gmap');

import ScrollCtrl from './include/_scroll';
import SwiperCtrl from './vendor/_swiper';
import NaviCtrl from './include/_gnavi';
import TouchCtrl from './include/_touch';
import SoundCtrl from './include/_audio';
import PopupCtrl from './vendor/_popup';

var scroll = new ScrollCtrl();
var swiper = new SwiperCtrl();
var navi = new NaviCtrl();
var touch = new TouchCtrl('a, button');
var sound = new SoundCtrl();
var popup = new PopupCtrl('.popup-link-video');